import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import { Box, SvgIconTypeMap, Tooltip, Typography } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import React, { useMemo } from "react"
import { customPalette } from "../../../../../../../../theme"
import { theme } from "../../../../../../../components/layout/BSLayout"

interface IProps {
  title: string
  icon: OverridableComponent<SvgIconTypeMap<unknown, "svg">>
  isSelectedTab?: boolean
  disabled?: boolean
  disabledText?: string
  showWarning?: boolean

  onClick(): void
}

export function BSLabelWithIcon({
  title,
  icon: Icon,
  isSelectedTab,
  onClick,
  disabled,
  disabledText = "",
  showWarning = false,
}: Readonly<IProps>): React.JSX.Element {
  const color = useMemo(() => {
    if (isSelectedTab) {
      return theme.palette.primary.dark
    } else if (disabled) {
      return customPalette.lightGray2
    } else {
      return customPalette.darkBlue3
    }
  }, [disabled, isSelectedTab])

  return (
    <Tooltip title={disabled ? disabledText : ""} arrow placement="right">
      <Box
        display="flex"
        justifyContent="space-between"
        onClick={() => {
          if (!disabled) {
            onClick()
          }
        }}
        sx={{
          display: "flex",
          padding: 1,
          backgroundColor: isSelectedTab ? customPalette.lightGreen9 : "transparent",
          borderRadius: "10px",
          color,
          ...(!disabled && {
            "&:hover": {
              backgroundColor: customPalette.lightGreen9,
              borderRadius: "10px",
            },
          }),
          ...(disabled && {
            cursor: "not-allowed",
          }),
        }}>
        <Box display="flex" alignItems="center" gap="8px">
          <Icon sx={{ color: "currentColor" }} />
          <Typography fontSize={14}>{title}</Typography>
        </Box>
        {showWarning && !disabled && (
          <Tooltip title="Veuillez finaliser la configuration de votre bâtiment">
            <ErrorOutlineIcon color="error" />
          </Tooltip>
        )}
      </Box>
    </Tooltip>
  )
}
